import { BaseError, createErrorBuilder, } from '@wix/public-editor-platform-errors';
export var EditorPlatformPrivateAPIErrorCode;
(function (EditorPlatformPrivateAPIErrorCode) {
    EditorPlatformPrivateAPIErrorCode["EditorPointerAPINotProvided"] = "The EditorPointerAPI was not provided";
    EditorPlatformPrivateAPIErrorCode["CantGetNamespace"] = "Can't get namespace in DefineNamespace decorator";
})(EditorPlatformPrivateAPIErrorCode || (EditorPlatformPrivateAPIErrorCode = {}));
class EditorPlatformPrivateAPIError extends BaseError {
    constructor(message, code) {
        super(message, code, 'Editor Platform Private API Error');
    }
    withDefineNamespaceData(data) {
        this.state = {
            ...this.state,
            ...data,
        };
        return this;
    }
    withNamespace(namespace) {
        this.state = {
            ...this.state,
            namespace,
        };
        return this;
    }
    withHostType(hostType) {
        this.state = {
            ...this.state,
            hostType,
        };
        return this;
    }
}
export const createEditorPlatformPrivateAPIError = createErrorBuilder(EditorPlatformPrivateAPIError);
//# sourceMappingURL=errors.js.map